<main id="main-content" class="container">
    <div class="row mb-3">
        <div class="col">
            <h2 i18n *ngIf="!hideInfo">Datos autorización</h2>
            <div class="card" *ngIf="!hideInfo">
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label for="vehicleType" class="form-label"><span i18n>Tipo de autorización que quiere
                                solicitar</span>: </label>
                        <select id="vehicleType" class="form-select" [(ngModel)]="newException.type.code"
                            (change)="changeType()" [disabled]="disablleAll">
                            <option value="">-----</option>
                            @for (vehicleType of vehiclesTypes; track vehicleType) {
                            <option value="{{vehicleType.code}}">{{vehicleType.name}}</option>
                            }
                        </select>
                    </div>
                    <div class="col-md-6 mb-3"
                        *ngIf="options.length > 0 && newException.type.code != 'MUNICIPAL' && newException.type.code != 'TRATMED'">
                        <label for="vehicleTypeOption" class="form-label"><span i18n>Tipo de servicio</span>: </label>
                        <select id="vehicleTypeOption" class="form-select" [(ngModel)]="tipServCode"
                            [disabled]="disablleAll">
                            <option value="">-----</option>
                            @for (option of options; track option) {
                            <option value="{{option.code}}">{{option.name}}</option>
                            }
                        </select>
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="poblation" class="form-label" *ngIf="newException.type.code != 'MUNICIPAL'"><span
                                i18n>¿Cuál es el municipio al que accederá por primera vez?</span></label>
                        <label for="poblation" class="form-label" *ngIf="newException.type.code == 'MUNICIPAL'"><span
                                i18n>¿Cuál es el municipio al que quiere acceder? </span></label>
                        <select id="poblation" class="form-select" [(ngModel)]="newException.municipality"
                            [disabled]="disablleAll">
                            <option value="">-----</option>
                            @for (municipality of municipalities; track municipality) {
                            <option value="{{municipality.municipality.municipalityName}}">
                                {{municipality.municipality.municipalityName}}</option>
                            }
                        </select>
                    </div>
                    <div class="col-md-6 mb-3" *ngIf="newException.type.code == 'VPMR'">
                        <label for="collectiveTransport" class="form-label"><span i18n>¿Es para transporte colectivo?</span>: </label>
                        <input class="form-check-input ml-3" type="checkbox"
                            [(ngModel)]="newException.type_vpmr!.collective" id="collectiveTransport"
                            [disabled]="disablleAll">
                    </div>
                    <div class="col-12 mb-3"
                        *ngIf="newException.type.code != 'MUNICIPAL' && newException.type.code != 'FOREIGN'">
                        <p i18n>Esta autorización permitirá acceder, circular y estacionar al vehículo por las zonas de
                            bajas emisiones de los municipios de este <a routerLink="/town-halls">listado</a>.</p>
                    </div>
                    <div class="col-12 mb-3">
                        <div [innerHTML]="descriptionTop"></div>
                        <div *ngIf="newException.type.code">
                            <a class="aaa-link" [routerLink]="'/autorizations/'+newException.type.code" target="_blank"
                                i18n>Más información sobre requisitos, tramitación y documentación de esta exención</a>
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" *ngIf="newException.type.code" i18n>Datos del vehículo</h2>

            <div class="card" *ngIf="newException.type.code && (!multiple && !newException.type_vpmr?.collective)">
                <div class="row" *ngIf="!vehicleFound">
                    <div class="col-md-6 mb-3">
                        <label for="vehicle" class="form-label"><span i18n>Vehículo</span>: </label>
                        <select id="vehicle" class="form-select" [(ngModel)]="selectedVehicle"
                            (change)="changeVehicle()" [disabled]="disablleAll">
                            <option value="new" i18n>Nuevo</option>
                            @for (vehicle of vehicles; track vehicle) {
                            <option value="{{vehicle.vehiclePlate}}">{{vehicle.vehicleAlias}}</option>
                            }
                        </select>
                    </div>
                </div>
                <div class="row" *ngIf="selectedVehicle !== 'new'">
                    <div class="col-md-6 mb-3">
                        <label for="plate" class="form-label"><span i18n>Matrícula</span> <span
                                class="required">*</span>: </label>
                        <input type="text" class="form-control" id="plate" [(ngModel)]="createdVehiclePlate" disabled>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="alias" class="form-label"><span i18n>Alias</span>:
                        </label>
                        <input type="text" class="form-control" id="alias" [(ngModel)]="createdVehicleAlias" disabled>
                    </div>
                    <div class="col-12 mb-3 check-legal">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="ownerDeclaration" id="titular" disabled>
                        <label for="titular" class="form-label ml-3 label-checkbox"><span i18n>¿Soy el titular del vehículo?</span></label>
                    </div>
                </div>
                <div class="row" *ngIf="selectedVehicle == 'new'">
                    @for (item of vehiclesToCreate; track $index) {
                    <div class="col-md-6 mb-3">
                        <label for="plate" class="form-label"><span i18n>Matrícula</span> <span
                                class="required">*</span>:
                        </label>
                        <input type="text" class="form-control" id="plate"
                            [(ngModel)]="vehiclesToCreate[$index].vehiclePlate" [disabled]="disablleAll">
                    </div>
                    <div class="col-md-5 mb-3">
                        <label for="alias" class="form-label"><span i18n>Alias</span>:
                        </label>
                        <input type="text" class="form-control" id="alias"
                            [(ngModel)]="vehiclesToCreate[$index].vehicleAlias" [disabled]="disablleAll">
                    </div>
                    <div class="col-md-1 mb-3 text-center" *ngIf="$index > 0">
                        <button class="btn btn-danger btn-small delete-veh" (click)="removeVehicle($index)">X</button>
                    </div>
                    <div class="col-12 mb-3 check-legal">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="vehiclesToCreate[$index].ownerDeclaration" id="titular" disabled>
                        <label for="titular" class="form-label ml-3 label-checkbox"><span i18n>¿Soy el titular del vehículo?</span></label>
                    </div>
                    }
                    <div class="col-12-mb-3" *ngIf="haveMultipleCars || newException.type_vpmr?.collective">
                        <button class="btn btn-primary" (click)="addVehicle()" i18n>Añadir vehículo</button>
                    </div>
                </div>
            </div>

            <div class="card" *ngIf="newException.type.code && (multiple || newException.type_vpmr?.collective)"
                id="table-vehicles">
                <div class="row">
                    <div class="col-12">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
                                <div class="card shadow text-center">
                                    <div class="card-body">
                                        <div class="circle-number">1</div>
                                        <p class="text-card-box" i18n>Descargar la plantilla</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
                                <div class="card shadow text-center">
                                    <div class="card-body">
                                        <div class="circle-number">2</div>
                                        <p class="text-card-box" i18n>Llena con los datos</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
                                <div class="card shadow text-center">
                                    <div class="card-body">
                                        <div class="circle-number">3</div>
                                        <p class="text-card-box" i18n>Sube el archivo</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
                                <div class="card shadow text-center">
                                    <div class="card-body">
                                        <div class="circle-number">4</div>
                                        <p class="text-card-box" i18n>Comprueba la tabla</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center">
                        <input type="file" id="upload-excel" (change)="loadFileMultiple($event)" multiple hidden>

                        <button class="btn btn-primary w-350 mt-3 mr-5" (click)="downloadExcel()">
                            <i class="bi bi-download mr-3"></i>
                            <span i18n>Descargar plantilla excel</span>
                        </button>
                        <button class="btn btn-primary w-350 mt-3 ml-5" (click)="triggerFileInput()">
                            <i class="bi bi-upload mr-3"></i>
                            <span i18n>Sube el archivo</span>
                        </button>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12">
                        <table class="table table-striped table-bordered table-responsive">
                            <thead>
                                <tr>
                                    <th scope="col" i18n>Matrícula</th>
                                    <th scope="col" i18n>Alias</th>
                                    <th scope="col" i18n>Mensaje</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (item of vehiclesFromExcel; track $index) {
                                <tr>
                                    <td>
                                        {{vehiclesFromExcel[$index].vehiclePlate}}
                                    </td>
                                    <td>
                                        {{vehiclesFromExcel[$index].vehicleAlias}}
                                    </td>
                                    <td>
                                        <span *ngIf="vehiclesFromExcel[$index].errorMessage"
                                            class="required">{{vehiclesFromExcel[$index].errorMessage}}</span>
                                        <span
                                            *ngIf="!vehiclesFromExcel[$index].errorMessage">{{vehiclesFromExcel[$index].correctMessage}}</span>
                                    </td>
                                </tr>
                                }
                                @if (vehiclesFromExcel.length == 0) {
                                <tr>
                                    <td colspan="3" class="text-center" i18n>No se han cargado vehículos</td>
                                </tr>
                                }
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>

            <h2 class="my-4" *ngIf="newException.type.code" i18n>Datos del interesado</h2>

            <div class="card" *ngIf="newException.type.code">
                <div *ngIf="applicant">
                    <h3 class="my-4" i18n>Tipo de solicitante</h3>

                    <div class="card">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <label for="tipo-solicitante" class="form-label">
                                    <span i18n>Tipo de solicitante</span>:
                                </label>
                                <select id="tipo-solicitante" class="form-select" [(ngModel)]="applicant.applicantType"
                                    disabled>
                                    <option value="Individual" i18n>Individual</option>
                                    <option value="Represented" *ngIf="showRepresent" i18n>Representado</option>
                                    <option value="Company" *ngIf="showCompany" i18n>Compañia</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <ng-container *ngIf="applicant.applicantType == 'Individual' && applicant.individual">
                        <h3 class="my-4" i18n>Datos del interesado</h3>

                        <div class="card">
                            <div class="row">
                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                                    <input disabled type="text" class="form-control" id="nombre"
                                        [(ngModel)]="applicant.individual.applicantIdentification.name">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="primer-apellido" class="form-label"><span i18n>Primer
                                            apellido</span>:</label>
                                    <input disabled type="text" class="form-control" id="primer-apellido"
                                        [(ngModel)]="applicant.individual.applicantIdentification.firstSurname">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="segundo-apellido" class="form-label"><span i18n>Segundo apellido</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="segundo-apellido"
                                        [(ngModel)]="applicant.individual.applicantIdentification.secondSurname">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="fecha-nacimiento" class="form-label"><span i18n>Fecha de
                                            nacimiento</span>:</label>
                                    <input disabled type="date" class="form-control" id="fecha-nacimiento"
                                        [(ngModel)]="applicant.individual.applicantIdentification.dateOfBirth.date">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="tipo-documento" class="form-label">
                                        <span i18n>Tipo de documento</span>:
                                    </label>
                                    <select disabled id="tipo-documento" class="form-select"
                                        [(ngModel)]="applicant.individual.applicantIdentification.documentType">
                                        <option value="">Seleccione una opción</option>
                                        <option value="NIF">NIF</option>
                                        <option value="NIE">NIE</option>
                                        <option value="Passport">Pasaporte</option>
                                        <option value="National ID">ID nacional</option>
                                    </select>
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="firstname" class="form-label"><span i18n>Numéro de
                                            documento</span>:</label>
                                    <input disabled type="text" class="form-control" id="firstname"
                                        [(ngModel)]="applicant.individual.applicantIdentification.documentIdentification">
                                </div>
                            </div>
                        </div>

                        <h2 class="my-4" i18n>Datos de contacto del interesado</h2>

                        <div class="card">
                            <div class="row">
                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="email" class="form-label"><span i18n>Email</span>:</label>
                                    <input disabled type="email" class="form-control" id="email" required
                                        [(ngModel)]="applicant.individual.applicantContact.email">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="telefono" class="form-label"><span i18n>Teléfono de contacto</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="telefono"
                                        [(ngModel)]="applicant.individual.applicantContact.phoneNumber">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="pais-residencia" class="form-label">
                                        <span i18n>País de residencia</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="pais-residencia"
                                        [(ngModel)]="countryName">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                                    <input disabled type="text" class="form-control" id="provincia"
                                        [(ngModel)]="applicant.individual.applicantContact.province">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                                    <input disabled type="text" class="form-control" id="municipio"
                                        [(ngModel)]="applicant.individual.applicantContact.municipality">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                                    <input disabled type="text" class="form-control" id="cp"
                                        [(ngModel)]="applicant.individual.applicantContact.postalCode">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                                    <select disabled id="stret-type" class="form-select"
                                        [(ngModel)]="applicant.individual.applicantContact.streetTypeCode">
                                        <option value="" i18n>Selecciona un tipo de vía</option>
                                        @for (strTyp of streetTypes; track strTyp.code) {
                                        <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                                        }
                                    </select>
                                </div>

                                <div class="col-sm-6 col-xl-6 mb-3">
                                    <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                                    <input disabled type="text" class="form-control" id="nombre-via"
                                        [(ngModel)]="applicant.individual.applicantContact.streetName">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                                    <input disabled type="text" class="form-control" id="numero"
                                        [(ngModel)]="applicant.individual.applicantContact.streetNumber">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                                    <input disabled type="text" class="form-control" id="piso"
                                        [(ngModel)]="applicant.individual.applicantContact.floor">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                                    <input disabled type="text" class="form-control" id="puerta"
                                        [(ngModel)]="applicant.individual.applicantContact.door">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                                    <input disabled type="text" class="form-control" id="stairCase"
                                        [(ngModel)]="applicant.individual.applicantContact.stairCase">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                                    <input disabled type="text" class="form-control" id="block"
                                        [(ngModel)]="applicant.individual.applicantContact.block">
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="applicant.applicantType == 'Represented' && applicant.represented">
                        <h3 class="my-4" i18n>Datos del interesado</h3>

                        <div class="card">
                            <div class="row">
                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                                    <input disabled type="text" class="form-control" id="nombre"
                                        [(ngModel)]="applicant.represented.applicantIdentification.name">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="primer-apellido" class="form-label"><span i18n>Primer
                                            apellido</span>:</label>
                                    <input disabled type="text" class="form-control" id="primer-apellido"
                                        [(ngModel)]="applicant.represented.applicantIdentification.firstSurname">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="segundo-apellido" class="form-label"><span i18n>Segundo apellido</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="segundo-apellido"
                                        [(ngModel)]="applicant.represented.applicantIdentification.secondSurname">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="fecha-nacimiento" class="form-label"><span i18n>Fecha de
                                            nacimiento</span>:</label>
                                    <input disabled type="date" class="form-control" id="fecha-nacimiento"
                                        [(ngModel)]="applicant.represented.applicantIdentification.dateOfBirth.date">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="tipo-documento" class="form-label">
                                        <span i18n>Tipo de documento</span>:
                                    </label>
                                    <select disabled id="tipo-documento" class="form-select"
                                        [(ngModel)]="applicant.represented.applicantIdentification.documentType">
                                        <option value="">Seleccione una opción</option>
                                        <option value="NIF">NIF</option>
                                        <option value="NIE">NIE</option>
                                        <option value="Passport">Pasaporte</option>
                                        <option value="National ID">ID nacional</option>
                                    </select>
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="firstname" class="form-label"><span i18n>Numéro de
                                            documento</span>:</label>
                                    <input disabled type="text" class="form-control" id="firstname"
                                        [(ngModel)]="applicant.represented.applicantIdentification.documentIdentification">
                                </div>

                                <div class="col-sm-6 mb-3">
                                    <label for="email" class="form-label"><span i18n>Email</span>:</label>
                                    <input disabled type="email" class="form-control" id="email" required
                                        [(ngModel)]="applicant.represented.applicantContact.email">
                                </div>
                            </div>
                        </div>

                        <h2 class="my-4" i18n>Datos de contacto del interesado</h2>

                        <div class="card">
                            <div class="row">

                                <div class="col-sm-6 mb-3">
                                    <label for="telefono" class="form-label"><span i18n>Teléfono de contacto</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="telefono"
                                        [(ngModel)]="applicant.represented.applicantContact.phoneNumber">
                                </div>

                                <div class="col-sm-6 mb-3">
                                    <label for="pais-residencia" class="form-label">
                                        <span i18n>País de residencia</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="pais-residencia"
                                        [(ngModel)]="countryName">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                                    <input disabled type="text" class="form-control" id="provincia"
                                        [(ngModel)]="applicant.represented.applicantContact.province">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                                    <input disabled type="text" class="form-control" id="municipio"
                                        [(ngModel)]="applicant.represented.applicantContact.municipality">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                                    <input disabled type="text" class="form-control" id="cp"
                                        [(ngModel)]="applicant.represented.applicantContact.postalCode">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                                    <select disabled id="stret-type" class="form-select"
                                        [(ngModel)]="applicant.represented.applicantContact.streetTypeCode">
                                        <option value="" i18n>Selecciona un tipo de vía</option>
                                        @for (strTyp of streetTypes; track strTyp.code) {
                                        <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                                        }
                                    </select>
                                </div>

                                <div class="col-sm-6 col-xl-6 mb-3">
                                    <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                                    <input disabled type="text" class="form-control" id="nombre-via"
                                        [(ngModel)]="applicant.represented.applicantContact.streetName">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                                    <input disabled type="text" class="form-control" id="numero"
                                        [(ngModel)]="applicant.represented.applicantContact.streetNumber">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                                    <input disabled type="text" class="form-control" id="piso"
                                        [(ngModel)]="applicant.represented.applicantContact.floor">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                                    <input disabled type="text" class="form-control" id="puerta"
                                        [(ngModel)]="applicant.represented.applicantContact.door">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                                    <input disabled type="text" class="form-control" id="stairCase"
                                        [(ngModel)]="applicant.represented.applicantContact.stairCase">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                                    <input disabled type="text" class="form-control" id="block"
                                        [(ngModel)]="applicant.represented.applicantContact.block">
                                </div>
                            </div>
                        </div>

                        <h2 class="my-4" i18n>Datos del representado</h2>

                        <div class="card">
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <label for="tipo-solicitante" class="form-label">
                                        <span i18n>Relación con el representado</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="tipo-solicitante"
                                        [(ngModel)]="applicant.represented.relationship">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                                    <input disabled type="text" class="form-control" id="nombre"
                                        [(ngModel)]="applicant.represented.representativeIdentification.name">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="primer-apellido" class="form-label"><span i18n>Primer
                                            apellido</span>:</label>
                                    <input disabled type="text" class="form-control" id="primer-apellido"
                                        [(ngModel)]="applicant.represented.representativeIdentification.firstSurname">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="segundo-apellido" class="form-label"><span i18n>Segundo apellido</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="segundo-apellido"
                                        [(ngModel)]="applicant.represented.representativeIdentification.secondSurname">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="fecha-nacimiento" class="form-label"><span i18n>Fecha de
                                            nacimiento</span>:</label>
                                    <input disabled type="date" class="form-control" id="fecha-nacimiento"
                                        [(ngModel)]="applicant.represented.representativeIdentification.dateOfBirth.date">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="tipo-documento" class="form-label">
                                        <span i18n>Tipo de documento</span>:
                                    </label>
                                    <select disabled id="tipo-documento" class="form-select"
                                        [(ngModel)]="applicant.represented.representativeIdentification.documentType">
                                        <option value="">Seleccione una opción</option>
                                        <option value="NIF">NIF</option>
                                        <option value="NIE">NIE</option>
                                        <option value="Passport">Pasaporte</option>
                                        <option value="National ID">ID nacional</option>
                                    </select>
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="firstname" class="form-label"><span i18n>Numéro de
                                            documento</span>:</label>
                                    <input disabled type="text" class="form-control" id="firstname"
                                        [(ngModel)]="applicant.represented.representativeIdentification.documentIdentification">
                                </div>
                            </div>
                        </div>

                        <h2 class="my-4" i18n>Datos de contacto del representado</h2>

                        <div class="card">
                            <div class="row">

                                <div class="col-sm-6 mb-3">
                                    <label for="telefono" class="form-label"><span i18n>Teléfono de contacto</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="telefono"
                                        [(ngModel)]="applicant.represented.representativeContact.phoneNumber">
                                </div>

                                <div class="col-sm-6 mb-3">
                                    <label for="pais-residencia" class="form-label">
                                        <span i18n>País de residencia</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="pais-residencia"
                                        [(ngModel)]="countryName">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                                    <input disabled type="text" class="form-control" id="provincia"
                                        [(ngModel)]="applicant.represented.representativeContact.province">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                                    <input disabled type="text" class="form-control" id="municipio"
                                        [(ngModel)]="applicant.represented.representativeContact.municipality">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                                    <input disabled type="text" class="form-control" id="cp"
                                        [(ngModel)]="applicant.represented.representativeContact.postalCode">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                                    <select disabled id="stret-type" class="form-select"
                                        [(ngModel)]="applicant.represented.representativeContact.streetTypeCode">
                                        <option value="" i18n>Selecciona un tipo de vía</option>
                                        @for (strTyp of streetTypes; track strTyp.code) {
                                        <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                                        }
                                    </select>
                                </div>

                                <div class="col-sm-6 col-xl-6 mb-3">
                                    <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                                    <input disabled type="text" class="form-control" id="nombre-via"
                                        [(ngModel)]="applicant.represented.representativeContact.streetName">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                                    <input disabled type="text" class="form-control" id="numero"
                                        [(ngModel)]="applicant.represented.representativeContact.streetNumber">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                                    <input disabled type="text" class="form-control" id="piso"
                                        [(ngModel)]="applicant.represented.representativeContact.floor">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                                    <input disabled type="text" class="form-control" id="puerta"
                                        [(ngModel)]="applicant.represented.representativeContact.door">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                                    <input disabled type="text" class="form-control" id="stairCase"
                                        [(ngModel)]="applicant.represented.representativeContact.stairCase">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                                    <input disabled type="text" class="form-control" id="block"
                                        [(ngModel)]="applicant.represented.representativeContact.block">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                                    <input disabled type="text" class="form-control" id="cp"
                                        [(ngModel)]="applicant.represented.representativeContact.postalCode">
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="applicant.applicantType == 'Company' && applicant.company">
                        <h3 class="my-4" i18n>Datos del interesado</h3>

                        <div class="card">
                            <div class="row">
                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                                    <input disabled type="text" class="form-control" id="nombre"
                                        [(ngModel)]="applicant.company.applicantIdentification.name">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="primer-apellido" class="form-label"><span i18n>Primer
                                            apellido</span>:</label>
                                    <input disabled type="text" class="form-control" id="primer-apellido"
                                        [(ngModel)]="applicant.company.applicantIdentification.firstSurname">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="segundo-apellido" class="form-label"><span i18n>Segundo apellido</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="segundo-apellido"
                                        [(ngModel)]="applicant.company.applicantIdentification.secondSurname">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="fecha-nacimiento" class="form-label"><span i18n>Fecha de
                                            nacimiento</span>:</label>
                                    <input disabled type="date" class="form-control" id="fecha-nacimiento"
                                        [(ngModel)]="applicant.company.applicantIdentification.dateOfBirth.date">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="tipo-documento" class="form-label">
                                        <span i18n>Tipo de documento</span>:
                                    </label>
                                    <select disabled id="tipo-documento" class="form-select"
                                        [(ngModel)]="applicant.company.applicantIdentification.documentType">
                                        <option value="">Seleccione una opción</option>
                                        <option value="NIF">NIF</option>
                                        <option value="NIE">NIE</option>
                                        <option value="Passport">Pasaporte</option>
                                        <option value="National ID">ID nacional</option>
                                    </select>
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="firstname" class="form-label"><span i18n>Numéro de
                                            documento</span>:</label>
                                    <input disabled type="text" class="form-control" id="firstname"
                                        [(ngModel)]="applicant.company.applicantIdentification.documentIdentification">
                                </div>

                                <div class="col-sm-6 mb-3">
                                    <label for="email" class="form-label"><span i18n>Email</span>:</label>
                                    <input disabled type="email" class="form-control" id="email" required
                                        [(ngModel)]="applicant.company.applicantContact.email">
                                </div>
                            </div>
                        </div>

                        <h2 class="my-4" i18n>Datos de contacto del interesado</h2>

                        <div class="card">
                            <div class="row">

                                <div class="col-sm-6 mb-3">
                                    <label for="telefono" class="form-label"><span i18n>Teléfono de contacto</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="telefono"
                                        [(ngModel)]="applicant.company.applicantContact.phoneNumber">
                                </div>

                                <div class="col-sm-6 mb-3">
                                    <label for="pais-residencia" class="form-label">
                                        <span i18n>País de residencia</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="pais-residencia"
                                        [(ngModel)]="countryName">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                                    <input disabled type="text" class="form-control" id="provincia"
                                        [(ngModel)]="applicant.company.applicantContact.province">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                                    <input disabled type="text" class="form-control" id="municipio"
                                        [(ngModel)]="applicant.company.applicantContact.municipality">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                                    <input disabled type="text" class="form-control" id="cp"
                                        [(ngModel)]="applicant.company.applicantContact.postalCode">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                                    <select disabled id="stret-type" class="form-select"
                                        [(ngModel)]="applicant.company.applicantContact.streetTypeCode">
                                        <option value="" i18n>Selecciona un tipo de vía</option>
                                        @for (strTyp of streetTypes; track strTyp.code) {
                                        <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                                        }
                                    </select>
                                </div>

                                <div class="col-sm-6 col-xl-6 mb-3">
                                    <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                                    <input disabled type="text" class="form-control" id="nombre-via"
                                        [(ngModel)]="applicant.company.applicantContact.streetName">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                                    <input disabled type="text" class="form-control" id="numero"
                                        [(ngModel)]="applicant.company.applicantContact.streetNumber">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                                    <input disabled type="text" class="form-control" id="piso"
                                        [(ngModel)]="applicant.company.applicantContact.floor">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                                    <input disabled type="text" class="form-control" id="puerta"
                                        [(ngModel)]="applicant.company.applicantContact.door">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                                    <input disabled type="text" class="form-control" id="stairCase"
                                        [(ngModel)]="applicant.company.applicantContact.stairCase">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                                    <input disabled type="text" class="form-control" id="block"
                                        [(ngModel)]="applicant.company.applicantContact.block">
                                </div>
                            </div>
                        </div>

                        <h2 class="my-4" i18n>Datos de la empresa</h2>

                        <div class="card">
                            <div class="row">
                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                                    <input disabled type="text" class="form-control" id="nombre"
                                        [(ngModel)]="applicant.company.identification.registeredName">
                                </div>
                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="tipo-documento" class="form-label">
                                        <span i18n>Tipo de documento</span>:
                                    </label>
                                    <select disabled id="tipo-documento" class="form-select"
                                        [(ngModel)]="applicant.company.identification.documentType">
                                        <option value="">Seleccione una opción</option>
                                        <option value="NIF">NIF</option>
                                        <option value="NIE">NIE</option>
                                        <option value="Passport">Pasaporte</option>
                                        <option value="National ID">ID nacional</option>
                                    </select>
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="firstname" class="form-label"><span i18n>Numéro de
                                            documento</span>:</label>
                                    <input disabled type="text" class="form-control" id="firstname"
                                        [(ngModel)]="applicant.company.applicantIdentification.documentIdentification">
                                </div>
                            </div>
                        </div>

                        <h2 class="my-4" i18n>Datos del representado</h2>

                        <div class="card">
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <label for="tipo-solicitante" class="form-label">
                                        <span i18n>Relación con el representado</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="tipo-solicitante"
                                        [(ngModel)]="applicant.company.relationship">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                                    <input disabled type="text" class="form-control" id="nombre"
                                        [(ngModel)]="applicant.company.representativeIdentification.name">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="primer-apellido" class="form-label"><span i18n>Primer
                                            apellido</span>:</label>
                                    <input disabled type="text" class="form-control" id="primer-apellido"
                                        [(ngModel)]="applicant.company.representativeIdentification.firstSurname">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="segundo-apellido" class="form-label"><span i18n>Segundo
                                            apellido</span>:</label>
                                    <input disabled type="text" class="form-control" id="segundo-apellido"
                                        [(ngModel)]="applicant.company.representativeIdentification.secondSurname">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="fecha-nacimiento" class="form-label"><span i18n>Fecha de
                                            nacimiento</span>:</label>
                                    <input disabled type="date" class="form-control" id="fecha-nacimiento"
                                        [(ngModel)]="applicant.company.representativeIdentification.dateOfBirth.date">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="tipo-documento" class="form-label">
                                        <span i18n>Tipo de documento</span>:
                                    </label>
                                    <select disabled id="tipo-documento" class="form-select"
                                        [(ngModel)]="applicant.company.representativeIdentification.documentType">
                                        <option value="">Seleccione una opción</option>
                                        <option value="NIF">NIF</option>
                                        <option value="NIE">NIE</option>
                                        <option value="Passport">Pasaporte</option>
                                        <option value="National ID">ID nacional</option>
                                    </select>
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="firstname" class="form-label"><span i18n>Numéro de
                                            documento</span>:</label>
                                    <input disabled type="text" class="form-control" id="firstname"
                                        [(ngModel)]="applicant.company.representativeIdentification.documentIdentification">
                                </div>
                            </div>
                        </div>

                        <h2 class="my-4" i18n>Datos de contacto del representado</h2>

                        <div class="card">
                            <div class="row">

                                <div class="col-sm-6 mb-3">
                                    <label for="telefono" class="form-label"><span i18n>Teléfono de
                                            contacto</span>:</label>
                                    <input disabled type="text" class="form-control" id="telefono"
                                        [(ngModel)]="applicant.company.representativeContact.phoneNumber">
                                </div>

                                <div class="col-sm-6 mb-3">
                                    <label for="pais-residencia" class="form-label">
                                        <span i18n>País de residencia</span>:
                                    </label>
                                    <input disabled type="text" class="form-control" id="pais-residencia"
                                        [(ngModel)]="countryName">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                                    <input disabled type="text" class="form-control" id="provincia"
                                        [(ngModel)]="applicant.company.representativeContact.province">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                                    <input disabled type="text" class="form-control" id="municipio"
                                        [(ngModel)]="applicant.company.representativeContact.municipality">
                                </div>

                                <div class="col-sm-6 col-xl-4 mb-3">
                                    <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                                    <input disabled type="text" class="form-control" id="cp"
                                        [(ngModel)]="applicant.company.representativeContact.postalCode">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                                    <select disabled id="stret-type" class="form-select"
                                        [(ngModel)]="applicant.company.representativeContact.streetTypeCode">
                                        <option value="" i18n>Selecciona un tipo de vía</option>
                                        @for (strTyp of streetTypes; track strTyp.code) {
                                        <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                                        }
                                    </select>
                                </div>

                                <div class="col-sm-6 col-xl-6 mb-3">
                                    <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                                    <input disabled type="text" class="form-control" id="nombre-via"
                                        [(ngModel)]="applicant.company.representativeContact.streetName">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                                    <input disabled type="text" class="form-control" id="numero"
                                        [(ngModel)]="applicant.company.representativeContact.streetNumber">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                                    <input disabled type="text" class="form-control" id="piso"
                                        [(ngModel)]="applicant.company.representativeContact.floor">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                                    <input disabled type="text" class="form-control" id="puerta"
                                        [(ngModel)]="applicant.company.representativeContact.door">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                                    <input disabled type="text" class="form-control" id="stairCase"
                                        [(ngModel)]="applicant.company.representativeContact.stairCase">
                                </div>

                                <div class="col-sm-6 col-xl-3 mb-3">
                                    <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                                    <input disabled type="text" class="form-control" id="block"
                                        [(ngModel)]="applicant.company.representativeContact.block">
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="newException.type.code == 'VPMR' && !newException.type_vpmr?.collective">
                        <h3 class="my-4" i18n>Datos de la persona con movilidad reducida si es menor de edad o es una
                            persona tutelada.</h3>

                        <div class="card">
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <div class="row">
                                        <div class="mb-1 check-legal">
                                            <input class="form-check-input" type="checkbox"
                                                [(ngModel)]="newException.type_vpmr!.anotherPerson" id="anotherPerson"
                                                [disabled]="disablleAll">
                                            <label for="anotherPerson" class="form-label ml-3 label-checkbox"><span
                                                    i18n>¿La persona con movilidad reducida es menor de edad o está tutelada?</span></label>
                                        </div>
                                        <div class="col-12" *ngIf="newException.type_vpmr!.anotherPerson">
                                            <p i18n>Por favor, a continuación introduzca los datos de la persona con
                                                movilidad reducida.</p>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-xl-4 mb-3"
                                            *ngIf="newException.type_vpmr!.anotherPerson">
                                            <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                                            <input type="text" class="form-control" id="nombre"
                                                *ngIf="newException.type_vpmr!.applicant"
                                                [(ngModel)]="newException.type_vpmr!.applicant.name"
                                                [disabled]="disablleAll">
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-xl-4 mb-3"
                                            *ngIf="newException.type_vpmr!.anotherPerson">
                                            <label for="primer-apellido" class="form-label"><span i18n>Primer
                                                    apellido</span>:</label>
                                            <input type="text" class="form-control" id="primer-apellido"
                                                *ngIf="newException.type_vpmr!.applicant"
                                                [(ngModel)]="newException.type_vpmr!.applicant.firstSurname"
                                                [disabled]="disablleAll">
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-xl-4 mb-3"
                                            *ngIf="newException.type_vpmr!.anotherPerson">
                                            <label for="segundo-apellido" class="form-label"><span i18n>Segundo
                                                    apellido</span>:</label>
                                            <input type="text" class="form-control" id="segundo-apellido"
                                                *ngIf="newException.type_vpmr!.applicant"
                                                [(ngModel)]="newException.type_vpmr!.applicant.secondSurname"
                                                [disabled]="disablleAll">
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-xl-4 mb-3"
                                            *ngIf="newException.type_vpmr!.anotherPerson">
                                            <label for="fecha-nacimiento" class="form-label"><span i18n>Fecha de
                                                    nacimiento</span>: <span class="required"
                                                    title="obligatorio">*</span></label>
                                            <input type="date" class="form-control" id="fecha-nacimiento"
                                                *ngIf="newException.type_vpmr!.applicant"
                                                [(ngModel)]="newException.type_vpmr!.applicant.dateOfBirth.date"
                                                [disabled]="disablleAll">
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-xl-4 mb-3"
                                            *ngIf="newException.type_vpmr!.anotherPerson">
                                            <label for="tipo-documento" class="form-label">
                                                <span i18n>Tipo de documento</span>: <span class="required"
                                                    title="obligatorio">*</span>
                                            </label>
                                            <select id="tipo-documento" class="form-select"
                                                *ngIf="newException.type_vpmr!.applicant"
                                                [(ngModel)]="newException.type_vpmr!.applicant.documentType"
                                                [disabled]="disablleAll">
                                                <option value="" i18n>Seleccione una opción</option>
                                                <option value="NIF" i18n>NIF</option>
                                                <option value="NIE" i18n>NIE</option>
                                                <option value="Passport" i18n>Pasaporte</option>
                                                <option value="National ID" i18n>ID nacional</option>
                                            </select>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-xl-4 mb-3"
                                            *ngIf="newException.type_vpmr!.anotherPerson">
                                            <label for="dni" class="form-label"><span i18n>Numero de documento de
                                                    identidad(NIF, NIE, pasaporte)</span>:</label>
                                            <input type="text" class="form-control" id="dni"
                                                *ngIf="newException.type_vpmr!.applicant"
                                                [(ngModel)]="newException.type_vpmr!.applicant.documentIdentification"
                                                [disabled]="disablleAll">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="newException.type.code == 'MALALT'">
                        <h3 class="my-4" i18n>Datos del centro médico:</h3>

                        <div class="card">
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <div class="row">
                                        <div class="col-12 mb-3">
                                            <div>
                                                <label class="form-label ml-3" i18n>El tipo de centro médico donde se
                                                    realiza el tratamiento es:</label>
                                                <select id="medicalCenter1" class="form-select"
                                                    [(ngModel)]="newException.type_malalt!.medicalCenter"
                                                    [disabled]="disablleAll">
                                                    <option value="" i18n>Seleccione una opción</option>
                                                    <option value="Hospital center of the catalan public" i18n>Centro
                                                        hospitalario de la red pública catalana</option>
                                                    <option value="Primary care center of the catalan public sector"
                                                        i18n>Centro de atención primaria de la red pública catalana
                                                    </option>
                                                    <option value="Other centers outside the catalan public sector"
                                                        i18n>Otros centros fuera de la red pública catalana</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-12 col-xl-12 mb-3"
                                            *ngIf="newException.type_malalt!.medicalCenter != '' && newException.type_malalt!.medicalCenter != 'Other centers outside the catalan public sector'">
                                            <label for="tsi" class="form-label"><span i18n>Número de tarjeta sanitaria
                                                    individual (TSI)</span>:</label>
                                            <input type="text" class="form-control" id="tsi"
                                                [(ngModel)]="newException.type_malalt!.TSI" [disabled]="disablleAll">
                                        </div>

                                        <div class="col-12 mb-3">
                                            <div class="mb-1 check-legal">
                                                <label class="form-label ml-3"><span i18n>Declaro bajo mi
                                                        responsabilidad</span>:</label>
                                            </div>
                                            <div class="mb-1 check-legal">
                                                <input class="form-check-input" type="checkbox"
                                                    [(ngModel)]="newException.type_malalt!.selfResponsibility"
                                                    id="selfResponsibility" [disabled]="disablleAll">
                                                <label for="selfResponsibility"
                                                    class="form-label ml-3 label-checkbox"><span i18n>Estoy
                                                        diagnosticado/a de una enfermedad o tengo una discapacidad
                                                        reconocida que condiciona el uso del transporte público y existe
                                                        una recomendación médica para no utilizar el transporte
                                                        público</span>.</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="newException.type.code == 'TRATMED'">
                        <h3 class="my-4" i18n>Datos del centro médico:</h3>

                        <div class="card">
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <div class="row">
                                        <div class="col-12 mb-3">
                                            <div>
                                                <label class="form-label ml-3" i18n>El tipo de centro médico donde se
                                                    realiza el tratamiento es:</label>
                                                <select id="medicalCenter" class="form-select"
                                                    [(ngModel)]="newException.type_tratmed!.medicalCenter"
                                                    [disabled]="disablleAll">
                                                    <option value="" i18n>Seleccione una opción</option>
                                                    <option value="Hospital center of the catalan public" i18n>Centro
                                                        hospitalario de la red pública catalana</option>
                                                    <option value="Primary care center of the catalan public sector"
                                                        i18n>Centro de atención primaria de la red pública catalana
                                                    </option>
                                                    <option value="Other centers outside the catalan public sector"
                                                        i18n>Otros centros fuera de la red pública catalana</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-12 col-xl-12 mb-3"
                                            *ngIf="newException.type_tratmed!.medicalCenter != '' && newException.type_tratmed!.medicalCenter != 'Other centers outside the catalan public sector'">
                                            <label for="tsi" class="form-label"><span i18n>Número de tarjeta sanitaria
                                                    individual (TSI)</span>:</label>
                                            <input type="text" class="form-control" id="tsi"
                                                [(ngModel)]="newException.type_tratmed!.TSI" [disabled]="disablleAll">
                                        </div>

                                        <div class="col-6 mb-3">
                                            <div>
                                                <label class="form-label ml-3" i18n>El tratamiento comienza el: </label>
                                                <input type="date" class="form-control" id="treatment"
                                                    min="{{today | date: 'yyyy-MM-dd'}}" [(ngModel)]="typeTratmedFrom"
                                                    [disabled]="disablleAll">
                                            </div>
                                        </div>

                                        <div class="col-6 mb-3">
                                            <div>
                                                <label class="form-label ml-3" i18n>El tratamiento finaliza el: </label>
                                                <input type="date" class="form-control" id="treatment"
                                                    [(ngModel)]="typeTratmedTo" [disabled]="disablleAll">
                                            </div>
                                        </div>

                                        <div class="col-12 mb-3">
                                            <div class="mb-1 check-legal">
                                                <label class="form-label ml-3"><span i18n>Declaro bajo mi
                                                        responsabilidad</span>:</label>
                                            </div>
                                            <div class="mb-1 check-legal">
                                                <input class="form-check-input" type="checkbox"
                                                    [(ngModel)]="newException.type_tratmed!.selfResponsibility"
                                                    id="selfResponsibility" [disabled]="disablleAll">
                                                <label for="selfResponsibility"
                                                    class="form-label ml-3 label-checkbox"><span i18n>Estoy
                                                        diagnosticado/a de una enfermedad o tengo una discapacidad
                                                        reconocida que condiciona el uso del transporte público y existe
                                                        una recomendación médica para no utilizar el transporte
                                                        público</span>.</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="newException.type.code == 'MUNICIPAL'">
                        <h3 class="my-4" i18n>Datos del evento</h3>

                        <div class="card">
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-6 mb-3">
                                            <label for="tipo-evento" class="form-label"><span i18n>Tipo de
                                                    evento</span>:</label>
                                            <select id="tipo-evento" class="form-select"
                                                [(ngModel)]="newException.type_municipal!.eventType"
                                                [disabled]="disablleAll">
                                                <option value="" i18n>Seleccione una opción</option>
                                                <option value="Filming" i18n>Filmación</option>
                                                <option value="Moving" i18n>Mudanza</option>
                                                <option value="Works" i18n>Obras</option>
                                                <option value="Shows" i18n>Espectáculos</option>
                                                <option value="Market" i18n>Mercado</option>
                                                <option value="Others" i18n>Otros</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-12 col-md-6 mb-3">
                                            <label for="descripcion" class="form-label" i18n>Descripción
                                                acontecimiento:</label>
                                            <input type="text" class="form-control" id="descripcion"
                                                [(ngModel)]="newException.type_municipal!.description"
                                                [disabled]="disablleAll">
                                        </div>
                                        <div class="col-sm-12 col-md-6 mb-3">
                                            <label for="fecha-inicio" class="form-label" i18n>Fecha de inicio:</label>
                                            <input type="date" class="form-control" id="fecha-inicio"
                                                [(ngModel)]="typeMunicipalFrom" [disabled]="disablleAll"
                                                [min]="today|date: 'yyyy-MM-dd'">
                                        </div>
                                        <div class="col-sm-12 col-md-6 mb-3">
                                            <label for="fecha-fin" class="form-label" i18n>Fecha de fin:</label>
                                            <input type="date" class="form-control" id="fecha-fin"
                                                [(ngModel)]="typeMunicipalTo" [disabled]="disablleAll"
                                                [min]="typeMunicipalFrom|date: 'yyyy-MM-dd'" [max]="maxDate">
                                        </div>
                                        <!-- <div class="col-sm-12 col-md-6 mb-3">
                                            <label for="municipio" class="form-label" i18n>Municipio:</label>
                                            <input type="text" class="form-control" id="municipio"
                                                [(ngModel)]="newException.type_municipal!.municipality">
                                        </div> -->
                                        <!-- <div class="col-sm-12 col-md-6 mb-3">
                                            <label for="provincia" class="form-label"><span
                                                    i18n>Provincia</span>:</label>
                                            <input type="text" class="form-control" id="provincia" *ngIf="newException.type_municipal!.address"
                                                [(ngModel)]="newException.type_municipal!.address.province"
                                                [disabled]="disablleAll">
                                        </div>

                                        <div class="col-sm-12 col-md-6 mb-3">
                                            <label for="municipio" class="form-label"><span
                                                    i18n>Municipio</span>:</label>
                                            <input type="text" class="form-control" id="municipio" *ngIf="newException.type_municipal!.address"
                                                [(ngModel)]="newException.type_municipal!.address.municipality"
                                                [disabled]="disablleAll">
                                        </div> -->
                                        <div class="col-sm-6 col-xl-3 mb-3"
                                            *ngIf="newException.type_municipal!.contact">
                                            <label for="stret-type" class="form-label"><span i18n>Tipo de
                                                    vía</span>:</label>
                                            <select id="stret-type" class="form-select"
                                                [(ngModel)]="newException.type_municipal!.contact.streetTypeCode"
                                                [disabled]="disablleAll">
                                                <option value="" i18n>Selecciona un tipo de vía</option>
                                                @for (strTyp of streetTypes; track strTyp.code) {
                                                <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                                                }
                                            </select>
                                        </div>
                                        <div class="col-sm-6 col-xl-6 mb-3"
                                            *ngIf="newException.type_municipal!.contact">
                                            <label for="nombre-via" class="form-label"><span i18n>Nombre de
                                                    vía</span>:</label>
                                            <input type="text" class="form-control" id="nombre-via"
                                                [(ngModel)]="newException.type_municipal!.contact.streetName"
                                                [disabled]="disablleAll">
                                        </div>
                                        <div class="col-sm-6 col-xl-3 mb-3"
                                            *ngIf="newException.type_municipal!.contact">
                                            <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                                            <input type="text" class="form-control" id="numero"
                                                *ngIf="newException.type_municipal!.contact"
                                                [(ngModel)]="newException.type_municipal!.contact.streetNumber"
                                                [disabled]="disablleAll">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="newException.type.code == 'PROF'">
                        <h3 class="my-4" i18n>Datos de la actividad profesional</h3>
                        <div class="card mt-3">
                            <div class="row">
                                <div class="col-12 mb-1">
                                    <div class="mb-1 check-legal">
                                        <input class="form-check-input" type="checkbox"
                                            [(ngModel)]="newException.type_prof!.selfResponsibility"
                                            id="selfResponsibility" [disabled]="disablleAll">
                                        <label for="selfResponsibility" class="form-label ml-3 label-checkbox"><span
                                                i18n>Declaro que este
                                                vehículo constituye un instrumento necesario para el ejercicio de mi
                                                actividad profesional.</span></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="newException.type.code == 'SALARY'">
                        <h3 class="my-4" i18n>Datos de unidad familiar</h3>
                        <div class="card mt-3">
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <div class="row">
                                        <div class="col-12 mb-3">
                                            <div class="mb-1 check-legal">
                                                <input class="form-check-input" type="checkbox"
                                                    [(ngModel)]="newException.type_salary!.hasRelation"
                                                    id="has-relation" [disabled]="disablleAll">
                                                <label for="has-relation" class="form-label ml-3 label-checkbox"
                                                    i18n>¿Tiene cónyuge o relación análoga?</label>
                                            </div>
                                            <div class="col-12 mb-3" *ngIf="newException.type_salary!.hasRelation">
                                                <label for="estado-civil" class="form-label"><span i18n>Estado
                                                        civil</span>:</label>
                                                <select id="estado-civil" class="form-select"
                                                    [(ngModel)]="newException.type_salary!.civilState"
                                                    [disabled]="disablleAll">
                                                    <option value="" i18n>Seleccione una opción</option>
                                                    <option value="Casado/a" i18n>Casado/a</option>
                                                    <option value="Soltero/a" i18n>Soltero/a</option>
                                                    <option value="Divorciado/a" i18n>Divorciado/a</option>
                                                    <option value="Separado/a" i18n>Separado/a</option>
                                                    <option value="Viudo/a" i18n>Viudo/a</option>
                                                    <option value="Relación análoga" i18n>Relación análoga</option>
                                                </select>
                                            </div>
                                            <div class="col-12 mb-3">
                                                <label for="unidad-familiar" class="form-label"><span i18n>Unidad
                                                        Familiar</span>:</label>
                                                <input type="number" class="form-control" id="unidad-familiar"
                                                    [(ngModel)]="newException.type_salary!.family" min="1"
                                                    (change)="clearNegative()" [disabled]="disablleAll">
                                            </div>
                                            <div class="col-12 mb-3">
                                                <p i18n>Son miembros de la unidad familiar la persona solicitante, el
                                                    cónyuge o la persona con la que mantenga una relación análoga de
                                                    afectividad y las personas menores de 25 años.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <h2 class="my-4" *ngIf="newException.type.code && !disablleAll" i18n>Ficheros</h2>

            <div class="card" *ngIf="newException.type.code && !disablleAll">
                <div class="row">
                    <div class="col-12 mb-3"
                        *ngIf="(newException.type.code != 'VPMR' && !newException.type_vpmr?.collective) || (newException.type.code == 'VPMR' && !newException.type_vpmr?.collective)">
                        <div [innerHTML]="descriptionFiles.split('--split--')[0]"></div>
                        <div class="mt-3 mb-3 check-legal" *ngIf="newException.type.code != 'FOREIGN'">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="newException.flags!.personal"
                                id="data-protection">
                            <label for="data-protection" class="ml-3">
                                <span i18n>
                                    NO CONSIENTO la consulta de los datos que están en poder de las administraciones
                                    públicas
                                    para la resolución de esta solicitud. Para más información haga clic
                                </span>
                                <a routerLink="/data-protection" target="_blank" i18n>aquí</a>.
                            </label>
                        </div>
                        <div [innerHTML]="descriptionFiles.split('--split--')[1]"></div>
                    </div>
                    <div class="col-12 mb-3"
                        *ngIf="newException.type.code == 'VPMR' && newException.type_vpmr?.collective">
                        <p i18n>En caso de que se autorice a realizar consultas a otras administraciones públicas y que
                            la consulta se resuelva con éxito, sólo tendrá que presentar documentación adicional.</p>

                        <div class="mb-3 check-legal">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="newException.flags!.personal"
                                id="data-protection">
                            <label for="data-protection" class="ml-3">
                                <span i18n>
                                    NO CONSIENTO la consulta de los datos que están en poder de las administraciones
                                    públicas
                                    para la resolución de esta solicitud. Para más información haga clic
                                </span>
                                <a routerLink="/data-protection" target="_blank" i18n>aquí</a>.
                            </label>
                        </div>
                        <p i18n>
                            Además, en caso de que se deniegue la consulta a otras administraciones, es necesario
                            presentar una copia de la siguiente documentación:
                        </p>
                        <ul>
                            <li i18n>
                                Tarjeta de inspección técnica con las adaptaciones realizadas en el vehículo para el
                                transporte colectivo de personas con movilidad reducida, o tarjeta de aparcamiento
                                colectivo.
                            </li>
                            <li i18n>
                                Documento de identificación del solicitante y/o representante (DNI, NIE, pasaporte).
                            </li>
                            <li i18n>
                                Permiso de circulación del vehículo.
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 mb-3">
                        <label for="formFileMultiple" class="form-label"><span i18n>Ficheros</span>: </label>
                        <div class="row mb-1" *ngIf="filesToShow[0]">
                            <div class="col-10">
                                <app-custom-input-file (onFileSelected)="loadFile($event, 0)"
                                    [id]="'0'"></app-custom-input-file>
                            </div>
                            <div class="col-1 text-center" *ngIf="filesToAdd[0] != undefined">
                                <button type="button" class="btn btn-danger btn-action" (click)="removeFile(0)"><i
                                        class="bi bi-trash"></i></button>
                            </div>
                        </div>
                        <div class="row mb-1" *ngIf="filesToShow[1]">
                            <div class="col-10">
                                <app-custom-input-file (onFileSelected)="loadFile($event, 1)"
                                    [id]="'1'"></app-custom-input-file>
                            </div>
                            <div class="col-1 text-center" *ngIf="filesToAdd[1] != undefined">
                                <button type="button" class="btn btn-danger btn-action" (click)="removeFile(1)"><i
                                        class="bi bi-trash"></i></button>
                            </div>
                        </div>
                        <div class="row mb-1" *ngIf="filesToShow[2]">
                            <div class="col-10">
                                <app-custom-input-file (onFileSelected)="loadFile($event, 2)"
                                    [id]="'2'"></app-custom-input-file>
                            </div>
                            <div class="col-1 text-center" *ngIf="filesToAdd[2] != undefined">
                                <button type="button" class="btn btn-danger btn-action" (click)="removeFile(2)"><i
                                        class="bi bi-trash"></i></button>
                            </div>
                        </div>
                        <div class="row mb-1" *ngIf="filesToShow[3]">
                            <div class="col-10">
                                <app-custom-input-file (onFileSelected)="loadFile($event, 3)"
                                    [id]="'3'"></app-custom-input-file>
                            </div>
                            <div class="col-1 text-center" *ngIf="filesToAdd[3] != undefined">
                                <button type="button" class="btn btn-danger btn-action" (click)="removeFile(3)"><i
                                        class="bi bi-trash"></i></button>
                            </div>
                        </div>
                        <div class="row mb-1" *ngIf="filesToShow[4]">
                            <div class="col-10">
                                <app-custom-input-file (onFileSelected)="loadFile($event, 4)"
                                    [id]="'4'"></app-custom-input-file>
                            </div>
                            <div class="col-1 text-center" *ngIf="filesToAdd[4] != undefined">
                                <button type="button" class="btn btn-danger btn-action" (click)="removeFile(4)"><i
                                        class="bi bi-trash"></i></button>
                            </div>
                        </div>
                        <div class="row mb-1" *ngIf="filesToShow[5]">
                            <div class="col-10">
                                <app-custom-input-file (onFileSelected)="loadFile($event, 5)"
                                    [id]="'5'"></app-custom-input-file>
                            </div>
                            <div class="col-1 text-center" *ngIf="filesToAdd[5] != undefined">
                                <button type="button" class="btn btn-danger btn-action" (click)="removeFile(5)"><i
                                        class="bi bi-trash"></i></button>
                            </div>
                        </div>
                        <div class="row mb-1" *ngIf="filesToShow[6]">
                            <div class="col-10">
                                <app-custom-input-file (onFileSelected)="loadFile($event, 6)"
                                    [id]="'6'"></app-custom-input-file>
                            </div>
                            <div class="col-1 text-center" *ngIf="filesToAdd[6] != undefined">
                                <button type="button" class="btn btn-danger btn-action" (click)="removeFile(6)"><i
                                        class="bi bi-trash"></i></button>
                            </div>
                        </div>
                        <div class="row mb-1" *ngIf="filesToShow[7]">
                            <div class="col-10">
                                <app-custom-input-file (onFileSelected)="loadFile($event, 7)"
                                    [id]="'7'"></app-custom-input-file>
                            </div>
                            <div class="col-1 text-center" *ngIf="filesToAdd[7] != undefined">
                                <button type="button" class="btn btn-danger btn-action" (click)="removeFile(7)"><i
                                        class="bi bi-trash"></i></button>
                            </div>
                        </div>
                        <div class="row mb-1" *ngIf="filesToShow[8]">
                            <div class="col-10">
                                <app-custom-input-file (onFileSelected)="loadFile($event, 8)"
                                    [id]="'8'"></app-custom-input-file>
                            </div>
                            <div class="col-1 text-center" *ngIf="filesToAdd[8] != undefined">
                                <button type="button" class="btn btn-danger btn-action" (click)="removeFile(8)"><i
                                        class="bi bi-trash"></i></button>
                            </div>
                        </div>
                        <div class="row mb-1" *ngIf="filesToShow[9]">
                            <div class="col-10">
                                <app-custom-input-file (onFileSelected)="loadFile($event, 9)"
                                    [id]="'9'"></app-custom-input-file>
                            </div>
                            <div class="col-1 text-center" *ngIf="filesToAdd[9] != undefined">
                                <button type="button" class="btn btn-danger btn-action" (click)="removeFile(9)"><i
                                        class="bi bi-trash"></i></button>
                            </div>
                        </div>
                        <small i18n>Tamaño de fichero máximo de 5MB</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-5" *ngIf="newException.type.code && !disablleAll">
        <div class="col-12">
            <div class="mb-3 check-legal">
                <input class="form-check-input" type="checkbox" [(ngModel)]="newException.flags!.privacity"
                    id="privacy">
                <label for="privacy" class="ml-3"><span i18n>Acepto la política de privacidad, para mas información haga
                        clic </span><a routerLink="/privacy" target="_blank" i18n>aquí</a>.</label>
            </div>
            <div class="mb-3 check-legal">
                <input class="form-check-input" type="checkbox" [(ngModel)]="newException.flags!.veracity" id="legal">
                <label for="legal" class="ml-3"><span i18n>El firmante responde personalmente sobre la veracidad de los
                        datos manifestados y acepta y es consciente de que, en caso de comprobarse la falsedad de los
                        datos expuestos en la solicitud, perderá cualquier derecho al servicio</span>.</label>
            </div>
            <div class="mb-3 check-legal"
                *ngIf="(newException.type.code == 'VPMR' || newException.type.code == 'TRATMED' || newException.type.code == 'MALALT') && !ownerDeclaration">
                <input class="form-check-input" type="checkbox" [(ngModel)]="newException.flags!.vehicleDocumentation"
                    id="titular">
                <label for="titular" class="ml-3">
                    <span i18n>En caso de que no sea el titular del vehículo, declaro que firmo teniendo la
                        documentación acreditativa correspondiente y habiendo informado al titular de todos los aspectos
                        legales.
                    </span>
                </label>
            </div>
        </div>
        <div class="col-12 mb-3 check-legal"
            *ngIf="newException.type.code != 'MUNICIPAL' && newException.type.code != 'FOREIGN'">
            <label i18n>En cumplimiento de lo dispuesto en la normativa de protección de datos vigente, se le informa
                que en función de la ZBE a la que haya presentado la documentación, sus datos serán tratados por los
                municipios de este <a routerLink="/town-halls">listado</a>, con la finalidad de tramitar su
                solicitud. Puede ejercer sus derechos y obtener más información consultando la <a
                    routerLink="/privacy">Política de Privacidad</a>.</label>
        </div>
        <div class="col-12 mb-3 check-legal"
            *ngIf="newException.type.code == 'MUNICIPAL' || newException.type.code == 'FOREIGN'">
            <label i18n>En cumplimiento de lo dispuesto en la normativa de protección de datos vigente, se le informa
                que en función de la ZBE a la que haya presentado la documentación, los datos facilitados serán tratados
                por el municipio correspondiente de este <a routerLink="/town-halls">listado</a>, con la finalidad de
                tramitar su solicitud. Puede ejercer sus derechos y obtener más información consultando la <a
                    routerLink="/privacy">Política de Privacidad</a>.</label>
        </div>
        <div class="col-12 text-center btn-actions">
            <button type="button" class="btn access btn-primary btn-rounded" (click)="save()" i18n>Crear</button>
            <button type="button" class="btn access btn-secondary btn-rounded" (click)="goBack()" i18n>Volver</button>
        </div>
    </div>
</main>